import React, { useEffect } from "react";
const ClientQRCodes = () => {
  useEffect(() => {
    document.title = "Snilink - QR codes";
  }, []);
  return (
    <>
      <h1 className="m-0 text-primary-900 dark:text-accent-100 md:text-2xl text-xl font-semibold mb-12px">
        QR Codes
      </h1>
      <p className="text-accent-400 "> Comming soon</p>
    </>
  );
};
export default ClientQRCodes;
